<template>
  <v-dialog v-model="previewDialog" max-width="500px" persistent>
    <template v-slot:activator="{ props: activatorProps }">
      <v-btn
        class="mx-2"
        :disabled="formula.length === 0"
        rounded="xl"
        size="small"
        variant="outlined"
        color="secondary"
        v-bind="activatorProps"
        @click="getPreview(formula)"
      >
        {{ $t("labels.validate") }}
      </v-btn>
    </template>
    <v-card>
      <v-toolbar :flat="true" color="secondary">
        <v-toolbar-title class="text-white">
          {{ $t("labels.formula-validation") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="white" icon @click="previewDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <v-card-text>
        <div class="mt-4 text-center">
          <div v-if="loading" class="text-caption">
            {{ $t("strings.loading-validation") }}
          </div>
          <div v-else class="text-body-2">
            <div v-if="resultPreview">
              <p class="mb-4 text-success font-weight-medium">
                {{ $t("strings.validation-positive") }}
              </p>
              <span class="text-primary">
                {{ $t("strings.validation-result") }}
              </span>
              <span>
                {{ resultPreview }}
              </span>
            </div>
            <div v-else>
              <p class="mb-4 text-error font-weight-medium">
                {{ $t("strings.validation-negative") }}
              </p>
              <p class="text-primary">
                {{ $t("strings.validation-suggestion") }}
              </p>
            </div>
          </div>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn variant="text" color="secondary" @click="previewDialog = false">
          {{ $t("labels.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "DialogValidateFormula",
  props: {
    formula: String,
    loading: Boolean,
    resultPreview: String,
  },
  data() {
    return {
      previewDialog: false,
    };
  },
  methods: {
    getPreview(formula) {
      this.$emit("getPreview", formula);
    },
  },
};
</script>
